import { render, staticRenderFns } from "./ExportTemplateSettings.vue?vue&type=template&id=673a3217&scoped=true"
import script from "./ExportTemplateSettings.vue?vue&type=script&lang=js"
export * from "./ExportTemplateSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a3217",
  null
  
)

export default component.exports